<template>
	<nut-navbar
		class="navbar"
		title="重置设备"
		leftShow
		@on-click-back="goBack"
	>
		<template #right>
			<nut-icon
				@click="handleOpenDialog(RESET_HELP)"
				class-prefix="icon"
				font-class-name="iconfont"
				name="question-circle"
			>
			</nut-icon>
		</template>
	</nut-navbar>
	<div class="container">
		<div class="warn">警告：重置后，数据和用户权限将被清空!</div>
		<div class="deviceId">
			<div class="label">设备编号</div>
			<div class="code">
				<span
					v-for="(item, index) in deviceArray"
					:key="item"
					class="num"
					:style="{ borderBottom: index === 0 ? 'none' : '' }"
				>
					{{ item }}
				</span>
			</div>
		</div>
		<div class="validBox">
			<div class="label">
				手机验证码
				<nut-icon
					@click="handleOpenDialog(VALID_CODE_HELP)"
					class-prefix="icon"
					font-class-name="iconfont"
					name="question-circle"
				>
				</nut-icon>
			</div>
			<div>
				<nut-input
					class="input"
					v-model="validCode"
					type="tel"
					placeholder="请输入手机验证码"
				>
					<template #button>
						<nut-button
							class="btn-send"
							:disabled="hasSendMsg || isDisabled"
							@click="handleSend"
							size="small"
							type="primary"
						>
							{{ hasSendMsg ? `${sendTime} s` : '获取验证码' }}
						</nut-button>
					</template>
				</nut-input>
			</div>
		</div>
		<div class="btn-container">
			<nut-button
				:disabled="isDisabled"
				type="primary"
				block
				@click="handleReset"
			>
				立即重置
			</nut-button>
		</div>
	</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Dialog, Toast } from '@nutui/nutui';
import useDialog from '@/hooks/useDialog';
import useNavigate from '@/hooks/useNavigate';
import useSendMessage from '@/hooks/useSendMessage';
import { VALID_CODE_HELP, RESET_HELP } from '@/constants/tiptype';
import { resetApi } from '@/apis';

export default {
	name: 'DevfeeReset',
	setup() {
		const store = useStore();
		const deviceArray = ref([]);
		const validCode = ref('');
		const phone = ref('');
		const isDisabled = ref(false);
		const { hasSendMsg, sendTime, handleSendMsg } = useSendMessage();
		const { goBack } = useNavigate();
		const { handleOpenDialog } = useDialog();

		const getData = async () => {
			const res = await resetApi.reset_load_data();
			deviceArray.value = res.device;
			phone.value = res.phone;
			isDisabled.value = res.disabled;
		};

		const handleSend = () => {
			handleSendMsg({}, 'reset');
		};

		const handleReset = async () => {
			if (!validCode.value) return Toast.warn('请输入手机验证码');
			Dialog({
				title: '提示',
				content: '设备重置后，所有数据会被清空。 是否继续？',
				async onOk() {
					await resetApi.reset_submit({
						devicenum: deviceArray.value.join(''),
						vcode: validCode.value,
					});
					Toast.success('设备重置成功，即将退出登录', {
						duration: 1500,
						onClose() {
							store.dispatch('user/logout');
						},
					});
				},
			});
		};

		onMounted(() => {
			getData();
		});

		return {
			deviceArray,
			validCode,
			hasSendMsg,
			sendTime,
			isDisabled,
			VALID_CODE_HELP,
			RESET_HELP,

			goBack,
			handleOpenDialog,
			handleReset,
			handleSend,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	overflow: hidden;
	background: $bg_color;

	.warn {
		height: 32px;
		line-height: 32px;
		color: #e64340;
		font-size: 14px;
		text-align: center;
		background: #fff;
	}

	.deviceId {
		background: #fff;
		margin: 10px 0;
		padding: 10px 0;
	}

	.label {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #999;
		padding: 10px;
	}

	.code {
		display: flex;
		justify-content: space-around;
	}

	.letter,
	.num {
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 24px;
		border-bottom: 1px solid #ddd;
		padding: 0 10px;
	}

	.letter {
		border-bottom: none;
	}

	.validBox {
		background: #fff;
		.input {
			padding: 0;
			border: none;
		}
		:deep(.input-text) {
			padding: 10px 0;
			padding-left: 10px;
			font-size: 12px;
			border-top: 1px solid #eaf0fb;
			border-bottom: 1px solid #eaf0fb;
		}

		.btn-send {
			position: absolute;
			right: 0;
			width: 100px;
			height: 100%;
			border-radius: 0;
			margin-left: 0;
		}
	}
}
</style>
